import { render } from "./DriversReporting.vue?vue&type=template&id=3fbfc67e&scoped=true"
import script from "./DriversReporting.vue?vue&type=script&lang=js"
export * from "./DriversReporting.vue?vue&type=script&lang=js"

import "./DriversReporting.vue?vue&type=style&index=0&id=3fbfc67e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\khale\\OneDrive\\Cookies BIS\\CookiesBIS\\core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fbfc67e"]])

export default __exports__